import styled from 'styled-components';

import { mediaBreakpoint } from '@commblades/commblades';

export const LoanOptionDescriptionDivWrapper = styled.div`
  &&& > ul {
    padding-left: 1.5rem;
  }
`;

export const LoanItemWrapper = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    max-width:100%;
    overflow-x: hidden;
  }
`;

export const LoanOptionWrapper = styled.div`
  &&& {
    display: flex;
    flex-grow: 10;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.Colors.Aliases.divider};
  }
  &&& > div {
    padding: 0 1.5rem 0 1.5rem;
  }  
`;

export const LoanItemHrWrapper = styled.hr`
  &&& {
    min-width: 100%;
  }
`;

export const OptionTabsWrapper = styled.div`
  &&& {
    list-style-type: none;
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    padding-bottom: 1.5rem;
  }
`;

export const ExceedInfoDivWrapper = styled.div`
  &&& {
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.Colors.Aliases.textAction};
    padding: 1rem;
    margin-bottom: 2rem;
  }
`;

type Props = {
  minHeight?: string;
};

export const ListWrapper = styled.ul<Props>`
  &&& {
    min-height: ${(props) => props.minHeight ?? '10vh'};
  }
  > li {
    list-style: disc !important;
  }
`;

export const OfferWrapper = styled.div`
  &&& {
    font-weight: 500;
  }
`;

export const DynamicMessageWrap = styled.div`
&&& {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.Colors.Aliases.hyperlinkDark};
}
`;
export const HiddenDynamicMessageWrap = styled.div`
&&& {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  border-width: 1px;
  border-style: solid;
  border-color: ${() => getComputedStyle(document.body, null).getPropertyValue('background-color')};
  visibility:hidden;
}
`;

export const RecommendPrimarySpanWrapper = styled.span`
  &&& {
    background-color: ${({ theme }) => theme.Colors.Aliases.brandBeacon};
    border-top-left-radius: 0.3125rem;
    border-top-right-radius: 0.3125rem;
    color: #1e1e1e;
    text-align: center;
    font-weight: 800;
    padding: 0.5rem;
  }
`;

export const RecommendSecondarySpanWrapper = styled.span`
  &&& {
    background-color: ${({ theme }) => theme.Colors.Aliases.backgroundLightSecondary};
    border-top-left-radius: 0.3125rem;
    border-top-right-radius: 0.3125rem;
    color: #1e1e1e;
    text-align: center;
    font-weight: 800;
    padding: 0.5rem;
  }
`;

export const LoanItemRepaymentContainerWrapper = styled.div`
  &&& > h4 {
    font-size: 0.875rem;
  }

  &&& .tooltip__content{
    left: calc(-1*var(--carousel-item-width)/3.3);
  }

  &&& .tooltip__content--top::after{
    left: calc(var(--carousel-item-width)/3.3);
  }

  &&& .tooltip__content--text{
    padding: 0;
  }
`;

export const LoanItemRepaymentDivWrapper = styled.div`
  &&& {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
  }
  
`;

export const LoanItemSpanWrapper = styled.span`
  &&& {
    font-size: 1.75rem;
    font-weight: 800;
  }
`;

export const LoanItemOfferContainerDivWrapper = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: start;
  }
`;

export const LoanItemOfferDivWrapper = styled.div<Props>`
  &&& {
    min-height: ${(props) => props.minHeight};
    margin-bottom: 1rem;
  }
  &&& .tooltip__content{
    left: -2rem;
    ${mediaBreakpoint.down('md')} {
      left: -3rem;
    }
    ${mediaBreakpoint.down('sm')} {
      left: -6rem;
    }
    padding: 2rem;
    width: 16rem;
  }

  &&& .tooltip__content--top::after{
    left: 2rem;
    ${mediaBreakpoint.down('md')} {
      left: 3rem;
    }
    ${mediaBreakpoint.down('sm')} {
      left: 6rem;
    }
  }

  &&& .tooltip__content--text{
    padding: 0;
  }
`;

export const LoanItemLearnMoreDivWrapper = styled.div`
  &&& {
    left: 2rem;
    margin: 0.5rem 0 0.5rem 0;
  }

  &&& .btn-action--subtle{
    margin: 0 !important;
  }
`;

export const LoanItemHeaderDivWrapper = styled.div`
  &&& {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-right: -1.5rem;
  }
`;
